<template>
  <div class="userGuideShadow" v-if="show" @click="hideView()">
    <div class="userGuideView">
      <img class="back" src="@/assets/goClass.png"/>
      <img class="arrow" :src="images.arrow"/>
      <p class="text">点击这里进入直播课程</p>
    </div>
  </div>
</template>

<script>
import {
  IMG_USER_GUIDE_ARROW
} from "@/assets"
import { SET_VALUE } from '@/utils';

export default {
  name: "UserGuide",
  components: {},
  props: {},
  data() {
    return {
      images:{
        arrow: IMG_USER_GUIDE_ARROW
      },
      show: true
    };
  },
  watch: {},
  computed: {

  },
  methods: {
    showView(){
      this.show = true
    },
    hideView(){
      this.show = false
      document.body.style.removeProperty("overflow");
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    document.body.style.setProperty("overflow", 'hidden');
    SET_VALUE("user_guide", "first");
  }
};
</script>

<style lang="less" scoped>
.userGuideShadow{
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  .userGuideView{
    width: 1000px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: auto;
    height: 100%;
  }
  .back{
    height: 44px;
    margin-top: 10px;
  }
  .arrow{
    width: 60px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .text{
    color: #FFAE00;
    margin-left: -20px;
  }
}
</style>
